import React from 'react';
import s from './Join.css';
import withStyles from "isomorphic-style-loader/withStyles";
import Container from "@material-ui/core/Container";
import HeadMessage from "../../components/Common/HeadMessage/HeadMessage";
import Button from "@material-ui/core/Button";
import clientConfig from '../../config/clientConfig';

class Join extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            chips: []
        };
    }

    render() {
        return (
            <div className={s.root}>
                <Container>
                    <HeadMessage>
                        <h3>{this.props.userName} invited you<br/> to try <span>New Tab Studio</span></h3>
                    </HeadMessage>

                    <Button
                        color={'primary'}
                        size={'large'}
                        variant={'contained'}
                        href={'/login/google'}
                    >
                        Sign in with Google
                    </Button>

                    <hr style={{ margin: 30 }}/>

                    Sign in and install New Tab Studio through this invite, and you'll get an extra {clientConfig.inviteBonus} widgets added to your {clientConfig.freeWidgets} free widgets
                </Container>
            </div>
        );
    }
}

export default withStyles(s)(Join);